export const MARKET_EVENTS = [
  {
    name: "COVID-19 Crash",
    start: "2020-02-19",
    end: "2020-03-23",
    description: "Sharp market decline due to COVID-19 pandemic",
    hideFromPicker: false,
  },
  {
    name: "2022 Bear Market",
    start: "2022-01-03",
    end: "2022-10-12",
    description: "Market decline due to inflation and rate hikes",
    hideFromPicker: false,
  },
  {
    name: "2008 Financial Crisis",
    start: "2008-09-15",
    end: "2009-03-09",
    description: "Global financial crisis following Lehman Brothers collapse",
    hideFromPicker: false,
  },
  // Add more market events as needed
];

/** Return events that overlap the given date range */
export function findMarketEvents(startDate, endDate) {
  if (!startDate || !endDate) return [];
  
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  return MARKET_EVENTS.filter(event => {
    const eventStart = new Date(event.start);
    const eventEnd = new Date(event.end);
    return (
      (eventStart >= start && eventStart <= end) ||
      (eventEnd >= start && eventEnd <= end) ||
      (eventStart <= start && eventEnd >= end)
    );
  });
}

/** Group events by year for coverage display */
export function groupEventsByYear(events) {
  return events.reduce((groups, event) => {
    const year = new Date(event.start).getFullYear();
    if (!groups[year]) groups[year] = [];
    groups[year].push(event);
    return groups;
  }, {});
}

/** Helper to get default date range */
export function getDefaultDates() {
  const end = new Date();
  end.setDate(end.getDate() - 4); // 4 days ago
  end.setHours(12, 0, 0, 0); // normalize to midday to avoid UTC rollover

  const start = new Date(end);
  start.setDate(start.getDate() - 354); // keep comfortably under 1 year
  start.setHours(12, 0, 0, 0); // normalize to midday to avoid UTC rollover

  return {
    start: start.toISOString().split('T')[0],
    end: end.toISOString().split('T')[0]
  };
}
